// This file was automatically generated from viewDocuments.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.viewDocuments');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FullHeight">');
  el8.template.multiuser_access.viewDocuments.rhsPanel(opt_data, output);
  el8.template.multiuser_access.viewDocuments.lhsThumbNavs(opt_data, output);
  el8.template.multiuser_access.viewDocuments.centerPane(opt_data, output);
  output.append('<div id="lead-gen-floater" class="hidden" ></div><div id="lead-gen-demo-floater" class="hidden" ></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.centerPane = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CenterPaneFax"><div class="el8CenterPaneFaxPad center-pane"></div><div class="w50p el8CenterBlock mbMd more-pages"><button class="el8Btn el8BtnDefault el8BtnBlock more-pages-button">Show more pages</button></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.leadGenFloater = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="floaterDialog"><div class="floaterDialogContainer">', (opt_data.role == 'clinician') ? '<h2><span class="el8FFF" >' + soy.$$escapeHtml(opt_data.userName) + '</span>, you are one of the hundreds of doctors who share clinical data with <strong class="el8FFF" >' + soy.$$escapeHtml(opt_data.collabNames) + '</strong> using Elation.' : '<h2><strong class="el8FFF" >' + soy.$$escapeHtml(opt_data.userName) + '</strong>, hundreds of practices share clinical data with <strong class="el8FFF" >' + soy.$$escapeHtml(opt_data.collabNames) + '</strong> using Elation.', '</h2><div class="floaterTextContainerSm"><p class="el8FFF">Elation is a fully functional and Meaningful Use 2014 Certified EMR.</p><p class="el8FFF">Let us show you how Elation can extend your care beyond your office through seamless, secure sharing of pertinent clinical data with your colleagues and patients.</p><div id="lead-gen-buttons" class="floaterButtonContainer"><a id="demo-button" data-id="', soy.$$escapeHtml(opt_data.linkUserId), '" class="start-trigger floaterButton">YES, I would like a demo</a><a id="later-button" class="start-trigger floaterButtonBlue" style="margin-left: 100px;">Later</a><a id="no-demo-button" class="start-trigger floaterButtonBlue">No Thanks</a></div><div id="no-demo-reason-container" class="hidden"><p class="el8FFF">Would you tell us why?</p><input type="text" id="no-demo-reason-input"></input><div class="floaterButtonContainer"><a id="no-demo-reason-submit" class="start-trigger floaterButton">Submit</a></div></div></div></div></div><div class="floaterBackground"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.leadGenDemoConfirmFloater = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="floaterDialog"><div class="floaterDialogContainer"><h2>Thank you.  We will be contacting you shortly.</h2></div></div><div class="floaterBackground"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.centerPaneImage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<img id="img-', soy.$$escapeHtml(opt_data.pageNum), '" class="el8PNGFull" src="', soy.$$escapeHtml(opt_data.viewPageLinkPrefix), soy.$$escapeHtml(opt_data.pageNum), '/screen/"/>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.lhsThumbNavs = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LeftPaneThumbNav"><div class="el8BoxPadSm lhs-thumb-nav"><ul class="el8ThumbNav lhs-thumb-list"></ul></div><div class="mbMd more-pages"><button class="el8Btn el8BtnDefault el8CenterBlock more-pages-button">Show more pages</button></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.lhsThumb = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li><a href="#img-', soy.$$escapeHtml(opt_data.pageNum), '"><div class="el8ThumbNavImg"><img src="', soy.$$escapeHtml(opt_data.viewPageLinkPrefix), soy.$$escapeHtml(opt_data.pageNum), '/thumb/" /><p>Page ', soy.$$escapeHtml(opt_data.pageNum), '</p></div></a></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.viewDocuments.rhsPanel = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8RightPaneFax"><div class="el8BoxPadMd">', (opt_data.senderPhotoUrl) ? '<img class="el8Thumbnail el8ThumbnailLeft" src="' + soy.$$escapeHtml(opt_data.senderPhotoUrl) + '"/>' : '<img class="el8Thumbnail el8ThumbnailLeft" src="/static/images/generic_e_avatar.png?v=20160729"/>', '<h5>To help you with seeing this patient, I\'ve prepared an interactive patient chart:</h5><button id="view-chart" class="el8Btn el8BtnPrimary el8BtnLg el8BtnBlock">Go to interactive patient chart</button><ul class="el8StandardList"><li><h4 class="noMargin">It\'s clinically efficient.</h4>Patient information is easier to navigate. Instantly find anything in the chart with the search bar.</li><li><h4 class="noMargin">Save time communicating.</h4><p>Send comments or your Consultation Report directly to this patient\'s chart ', (opt_data.senderLastName) ? 'in Dr. ' + soy.$$escapeHtml(opt_data.senderLastName) + '\'s EMR' : '', '.</p></li></ul><div class="el8SmSpacer"></div><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(opt_data.printPDFLink), '" id="print-link" class="el8Btn el8BtnDefault el8BtnLg el8BtnBlock">Print</a><a href="', soy.$$escapeHtml(opt_data.downloadPDFLink), '" id="save-to-computer-link" class="el8Btn el8BtnDefault el8BtnLg el8BtnBlock">Save to Computer</a></div><div class="el8RightPaneFaxBottom"><div><p class="noMargin el8BoxPadSm"><a href="" class="view-log el8ExpandLink"><span class="view-log-status el8Collapsed"></span>Who has viewed this document?</a></p><ul class="el8FaxViewList view-log-entries">');
  var readLogList318 = opt_data.readLogs;
  var readLogListLen318 = readLogList318.length;
  for (var readLogIndex318 = 0; readLogIndex318 < readLogListLen318; readLogIndex318++) {
    var readLogData318 = readLogList318[readLogIndex318];
    output.append('<li><span class="el8ListLabel">', soy.$$escapeHtml(readLogData318.time), '</span>', soy.$$escapeHtml(readLogData318.name), '</li>');
  }
  output.append('</ul></div></div></div>');
  if (!opt_sb) return output.toString();
};
